module.exports = __webpack_public_path__ + "static/media/Delay (Slapback delay) VR.15870a1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedal/Delay (Slapback delay) VR.mp3
// module id = 3bt/
// module chunks = 12